import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import classNames from 'classnames';

import styles from './prev-next-buttons.module.css';

/* eslint-disable-next-line */
export interface PrevNextButtonsProps {
  onPrev?: () => void;
  onNext?: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

export function PrevNextButtons(props: PrevNextButtonsProps) {
  return (
    <div className={styles.container}>
      <button
        aria-label="Previous"
        className={classNames('lidea-btn', 'lidea-btn--ghost', styles.navBtn)}
        disabled={props.prevDisabled}
        type="button"
        onClick={props.onPrev}
      >
        <IconChevronLeft size={20} stroke={1.75} />
      </button>
      <button
        aria-label="Next"
        className={classNames('lidea-btn', 'lidea-btn--ghost', styles.navBtn)}
        disabled={props.nextDisabled}
        type="button"
        onClick={props.onNext}
      >
        <IconChevronRight size={20} stroke={1.75} />
      </button>
    </div>
  );
}

export default PrevNextButtons;
